import { Component } from 'vue-property-decorator';
import Base from '@/components/Base';

@Component({})
export default class ActingAsBanner extends Base {
  get originalUsername() {
    return this.currentUser.original_username;
  }

  get currentUsername() {
    return this.currentUser.username;
  }

  stopActingAs() {
    window.location.href = 'api/v1/stop-acting-as';
  }
}
